<template>
  <div class="box">
    <template v-if="success">
      <i class="el-icon-success icon-success" />
      <p>
        {{ $t('account.registerSuccess') }}
        <el-button
          class="to-login-btn"
          type="text"
          @click="handleToLogin"
        >
          {{ $t('account.toLogin') }}
        </el-button>
      </p>
    </template>
    <template v-if="errMsg">
      <i class="el-icon-error icon-error" />

      <p>
        {{ errMsg }}
      </p>
    </template>
  </div>
</template>
<script>
import authService from '@/api/auth'
import { getErrorCode, getDefaultErrorText } from './mixin'

export default {
  name: 'RegisterSuccess',

  data() {
    return {
      errMsg: '',
      success: false
    }
  },

  created() {

  },

  beforeRouteEnter(to, from, next) {
    const { email, time, token } = to.query
    if (email && time && token) {
      next()
    } else {
      next('/')
    }
  },

  mounted() {
    this.init()
  },

  methods: {
    async init() {
      const { email, time, token } = this.$route.query
      this.$router.replace({ query: {} })
      try {
        const { code } = await authService.registerCallback({
          email,
          time,
          token
        })
        if (code === 200) {
          this.success = true
        } else {
          this.errMsg = getErrorCode()[code]
        }
      } catch (e) {
        this.errMsg = getDefaultErrorText()
      }
    },
    handleToLogin() {
      this.$router.push({
        name: 'homePage'
      })
      this.$nextTick(() => {
        this.$store.commit('login', true)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.box {

  text-align: center;
  .icon-success {
    font-size: 100px;
    color: #67C23A
  }

  .icon-error {
    font-size: 100px;
    color: #F56C6C;
  }

  p {
    margin-top: 20px;
    font-size: 20px;
  }
}

.to-login-btn {
  font-size: 20px;
}

</style>
